/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminnav_Management1Inputs */

const zh_adminnav_management1 = /** @type {(inputs: Adminnav_Management1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理员设置`)
};

const en_adminnav_management1 = /** @type {(inputs: Adminnav_Management1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin Settings`)
};

const es_adminnav_management1 = /** @type {(inputs: Adminnav_Management1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de administrador`)
};

/**
* | output |
* | --- |
* | "Admin Settings" |
*
* @param {Adminnav_Management1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminnav_management1 = /** @type {((inputs?: Adminnav_Management1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminnav_Management1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminnav_management1(inputs)
	if (locale === "en") return en_adminnav_management1(inputs)
	return es_adminnav_management1(inputs)
});
export { adminnav_management1 as "adminNav_management" }